export default "__VITE_ASSET__DuCcHyGv__"